// extracted by mini-css-extract-plugin
export default {"container":"ManufactureConnectionFields_container__3hfuL","field":"ManufactureConnectionFields_field__NUd2L"};